<script setup lang="ts">
defineProps<{
  quote: string;
  attribution?: string | null;
}>();
</script>

<template>
  <blockquote class="block-quote">
    <p class="block-quote__text">{{ quote }}</p>
    <footer v-if="attribution" class="block-quote__attribution">— {{ attribution }}</footer>
  </blockquote>
</template>

<style scoped>
.block-quote {
  margin: 1.5em 0;
  padding-left: 1em;
  border-left: 4px solid var(--color-border, #ccc);
  font-style: italic;
}
.block-quote__text {
  margin: 0;
}
.block-quote__attribution {
  margin-top: 0.5em;
  font-size: 0.9em;
  font-style: normal;
  color: var(--color-text-muted, #666);
}
</style>
